export default {
  labels: {
    sold_out: 'Ausverkauft',
  },
};
